import { getArticleById } from '@/mocks/articles';
import { useParams } from 'react-router-dom';

export default function ArticleHero() {
  const { id } = useParams<{ id: string }>();
  const articleDetail = getArticleById(id);

  return (
    <section className="relative w-full h-[360px] md:h-[480px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={articleDetail.imageUrl}
          alt={articleDetail.title}
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-end pb-10 md:pb-14 px-4">
        <div className="flex items-center gap-2 mb-4">
          <span className="px-3 py-1 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-bold whitespace-nowrap">
            {articleDetail.category}
          </span>
          <span className="text-background-50/60 text-xs">
            {new Date(articleDetail.publishedAt).toLocaleDateString('zh-CN', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        </div>

        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 text-center max-w-4xl leading-tight">
          {articleDetail.title}
        </h1>

        <p className="mt-4 text-sm md:text-base text-background-50/70 text-center max-w-2xl leading-relaxed">
          {articleDetail.summary}
        </p>

        <div className="mt-6 flex items-center gap-5 text-xs text-background-50/50">
          <span className="flex items-center gap-1.5">
            <i className="ri-user-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {articleDetail.author}
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {(articleDetail.views / 10000).toFixed(0)}万阅读
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-message-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
            {articleDetail.comments}评论
          </span>
        </div>
      </div>
    </section>
  );
}
